<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-xl-3">
        <BranchStatsPanel />
      </div>
      <!-- end col -->
      <div class="col-xl-9">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Create User</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <CreateUserForm></CreateUserForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>

import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "Create User",
    meta: [{ name: "Create User", content: window.__env.app.description }]
  },

  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "CreateUser",
      title: "Create User",
      items: [
        {
          text: "User",
          href: "/"
        },
        {
          text: "Create User",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
